import './App.scss';
import {Route, Routes} from "react-router-dom";
import SignUpPage from "./sign_up_page";
import Footer from "./footer";
import VerificationPage from "./verification_page";
import SignInPage from "./sign_in_page";
import DashboardPage from "./dashboard_page";
import {useEffect, useState} from "react";
import {AuthenticationContext} from "./authentication";
import {AuthenticationProtected} from "./authentication_protected";
import MachinePage from "./machine_page";
import DispenseSuccessPage from "./dispense_success_page";
import AllVendingMachinesPage from "./all_vending_machines_page";
import CoolingOffPage from "./cooling_off_page";

function App() {
    const [authentication, setAuthentication] = useState({
        authenticated:null,
        mobile:null,
        authentication_token:null
    });

    const login = (token, identifier)=>{
        localStorage.setItem("authToken", token);

        reloadMyInfo(token, identifier)
    }

    const reloadMyInfo = (token, identifier)=>{
        // FIXME: We need to check whether the saved token is valid with the backend
        if (token != null){
            setAuthentication({
                authenticated: true,
                mobile: identifier,
                authorization_token: token
            })
        } else {
            setAuthentication({
                authenticated: false,
                mobile: "",
                authorization_token: ""
            })
            localStorage.removeItem("authToken");
            localStorage.removeItem("mobile");
            localStorage.removeItem("email");
            localStorage.removeItem("registrationMethod");
        }
    }

    const init = () => {
        // Handle email verification redirect from backend
        const params = new URLSearchParams(window.location.search);
        const authTokenParam = params.get("auth_token");
        const identifierParam = params.get("identifier");
        if (authTokenParam && identifierParam) {
            // Store credentials and clean URL
            localStorage.setItem("authToken", authTokenParam);
            if (identifierParam.includes("@")) {
                localStorage.setItem("email", identifierParam);
                localStorage.setItem("registrationMethod", "email");
            } else {
                localStorage.setItem("mobile", identifierParam);
                localStorage.setItem("registrationMethod", "phone");
            }
            window.history.replaceState({}, document.title, "/");
            login(authTokenParam, identifierParam);
            return;
        }

        // Handle error redirects from backend
        const error = params.get("error");
        if (error) {
            const messages = {
                invalid_token: "This verification link is invalid.",
                already_used: "This verification link has already been used.",
                expired: "This verification link has expired. Please sign in again to get a new one.",
            };
            if (messages[error]) {
                window.alert(messages[error]);
            }
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        // Migrate legacy localStorage keys
        const legacyIdentifier = localStorage.getItem("identifier");
        if (legacyIdentifier && !localStorage.getItem("mobile") && !localStorage.getItem("email")) {
            if (legacyIdentifier.includes("@")) {
                localStorage.setItem("email", legacyIdentifier);
                localStorage.setItem("registrationMethod", "email");
            } else {
                localStorage.setItem("mobile", legacyIdentifier);
                localStorage.setItem("registrationMethod", "phone");
            }
            localStorage.removeItem("identifier");
        }

        let identifier = localStorage.getItem("mobile") || localStorage.getItem("email");
        let token = localStorage.getItem("authToken");
        if (identifier != null && token != null){
            login(token, identifier)
        } else {
            setAuthentication({
                authenticated:false,
                mobile:null,
                authentication_token:null
            })
        }
    }

	// eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(init, [])


  return (
      <div className={"d-flex flex-column min-vh-100 backgroundPrimary"}>
          <AuthenticationContext.Provider value={{
              authentication:authentication,
              logout:()=>{},
              login:login
          }}>
              <div className="flex-grow-1">
                  <Routes>
                      <Route exact path="sign_in" element={<SignInPage/>}/>
                      <Route exact path="sign_up" element={<SignUpPage/>}/>
                      <Route exact path="verification" element={<VerificationPage/>}/>
                      <Route exact path="/" element={<AuthenticationProtected><DashboardPage/></AuthenticationProtected>}/>
                      <Route exact path="machines" element={<AuthenticationProtected><AllVendingMachinesPage/></AuthenticationProtected>}/>
                      <Route exact path="machines/:vmId" element={<AuthenticationProtected><MachinePage/></AuthenticationProtected>}/>
                      <Route exact path="dispense/:id/success" element={<AuthenticationProtected><DispenseSuccessPage/></AuthenticationProtected>}/>
                      <Route exact path="cooling_off" element={<AuthenticationProtected><CoolingOffPage/></AuthenticationProtected>}/>
                  </Routes>
              </div>
          </AuthenticationContext.Provider>
          <Footer/>
      </div>
  );
}

export default App;
